import * as React from "react";
const SvgPercentage = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m18.501 3.5-15 15.001 1.996 1.996 15-15zM7.002 5a2 2 0 1 0-.004 4 2 2 0 0 0 .004-4zm10 10a2 2 0 1 0-.004 4 2 2 0 0 0 .004-4z",
  fill: "currentColor"
}));
export default SvgPercentage;